import { useRecoilState } from 'recoil';
import { useEffect, Fragment, useState } from 'react';
import { userAtom } from './atoms/user';
// routes
import Router from './routes';
// theme
// components
import ScrollToTop from './components/ScrollToTop';
import { tokenAtom } from './atoms/token';
import { useIsAuthenticated, useMsal, useMsalAuthentication } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import axios from 'axios';
import { useQuery } from 'react-query';
import ErrorPage from './pages/ErrorPage';
import LoadingPage from './pages/Loading';
import { getImage } from './services/images.services';
import UserDoesnotExistPage from './pages/UserDoesnotExistPage';
// ----------------------------------------------------------------------

export default function App() {
  const [user, setUser] = useRecoilState(userAtom);
  const [, setToken] = useRecoilState(tokenAtom);
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const { result } = useMsalAuthentication(InteractionType.Popup, {
    scopes: ['user.read']
  });
  const getMyData = (idToken) =>
    axios({
      method: 'get',
      url: '/me',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`
      }
    });

  const currentAccount = instance.getActiveAccount();
  const { isLoading, isError, data, error } = useQuery(
    ['getMyData', result],
    () => getMyData(result.idToken),
    {
      enabled: !!currentAccount && !!result && isAuthenticated
    }
  );

  const [imageKey, setImageKey] = useState(null);
  useEffect(() => {
    if (data) {
      setImageKey(data.data.profile_picture);
    }
  }, [data]);
  const {
    isLoading: loadingProfilePic,
    isError: isErrorProfilePic,
    error: errorProfilePic,
    data: resultProfilePic
  } = useQuery(
    ['profile_pic', imageKey],
    async () => {
      return await getImage(imageKey);
    },
    {
      enabled: !!user && !!data && !!imageKey
    }
  );

  console.log("don't look there");
  useEffect(() => {
    const currentAccount = instance.getActiveAccount();
    if (currentAccount && result) {
      instance.setActiveAccount(currentAccount);
      setToken(result.accessToken);
      //save token in local storage
      localStorage.setItem('v', result.idToken);
    }
  }, [result, isAuthenticated]);

  useEffect(() => {
    if (data) {
      setUser({
        ...data.data
      });
    }

    if (resultProfilePic) {
      setUser({
        ...user,
        profile_picture: resultProfilePic
      });
    }
  }, [data, resultProfilePic]);

  if (isError || isErrorProfilePic) {
    if (error?.response?.data?.statusCode === 404) {
      return <UserDoesnotExistPage />;
    }
    return <ErrorPage error={error || errorProfilePic} />;
  }

  if (isLoading || !data || !user.id || loadingProfilePic) {
    return <LoadingPage loading={true} />;
  }

  return (
    <Fragment>
      <ScrollToTop />
      <Router />
    </Fragment>
  );
}
